import { render, staticRenderFns } from "./SliderForthArrow.vue?vue&type=template&id=831ff8a8&"
import script from "./SliderForthArrow.vue?vue&type=script&lang=js&"
export * from "./SliderForthArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports